// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 966 ? "dashboard" : chunkId) + "." + {"31":"bf8a6b04","962":"1dc04662","966":"36f939bf"}[chunkId] + ".css";
};